import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../Api.jsx';
import { toast } from 'react-toastify';

const Register = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('user'); // "user" selezionato di default
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      const msg = 'Le password non coincidono';
      setError(msg);
      toast.error(msg);
      return;
    }

    try {
      // Manda i dati al backend
      const response = await api.post('/user/register', {
        firstName,
        lastName,
        email,
        role,
        password,
        
        
      });

      // Se il backend restituisce semplicemente l’utente:
      // const data = response.data;
      // Se serve salvare un token, ricorda di farlo restituire dal backend e memorizzarlo qui:
      // localStorage.setItem('token', data.token);

      toast.success('Registrazione completata con successo!');
      navigate('/');
    } catch (err) {
      if (err.response) {
        if (err.response.data.errors) {
          const firstError = err.response.data.errors[0]?.msg || 'Errore di validazione';
          setError(firstError);
          toast.error(firstError);
        } else {
          const msg = err.response.data.error || 'Registrazione fallita';
          setError(msg);
          toast.error(msg);
        }
      } else {
        setError('Errore di connessione al server');
        toast.error('Errore di connessione al server');
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-global px-4">
      <div className="w-full max-w-md bg-primary p-8 rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-6 text-white">Crea un nuovo account</h2>

        {error && (
          <div className="mb-4 p-3 text-sm text-red-700 bg-red-100 border border-red-300 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-white mb-1">Nome</label>
            <input
              type="text"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-1">Cognome</label>
            <input
              type="text"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-1">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Tendina per la scelta del ruolo */}
          <div>
            <label className="block text-sm font-medium text-white mb-1">Ruolo</label>
            <select
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="user">user</option>
              <option value="rup">rup</option>
              <option value="supervisore">supervisore</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-1">Password</label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-1">
              Conferma Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-emerald-700 hover:bg-emerald-900 text-white font-semibold rounded-xl transition duration-300"
          >
            Registrati
          </button>
        </form>

        <p className="text-sm text-gray-500 mt-4 text-center">
          Hai già un account?{' '}
          <span
            onClick={() => navigate('/login')}
            className="text-emerald-700 hover:underline cursor-pointer"
          >
            Accedi
          </span>
        </p>
      </div>
    </div>
  );
};

export default Register;
